import find from 'lodash/find';
import store from '@Store';
import { fullTextDocumentId as fullTextDocumentIdSelector } from '../HopintoSelectors';
import { setFullTextDocumentId as setFullTextDocumentIdAction } from '../HopintoActions';

export function getFullTextDocumentId() {
  return fullTextDocumentIdSelector(store.getState());
}

export function setFullTextDocumentId(fullTextDocumentId) {
  return store.dispatch(setFullTextDocumentIdAction({ fullTextDocumentId }));
}

export function processResultsItemsForFullTextDocumentId(items) {
  const fullTextDocumentId = getFullTextDocumentId();
  const result = find(items, { id: fullTextDocumentId });

  if (result) {
    const { fullTextUrl, fullTextCustom } = result;

    if (!fullTextUrl) {
      Logger.error('Hopinto/FullTextResults - invalid fullTextUrl', fullTextUrl);
      setFullTextDocumentId(null);
      return;
    }

    if (fullTextCustom) {
      setFullTextDocumentId(null);
      window.location.assign(fullTextUrl);
    }
  }
}
